import { z } from "zod/v4";

import {
  PatchStripeSubscriptionLinkDtoSchema,
  StripeSubscriptionLinkDtoSchema,
} from "../../../dtos/stripe-subscription-links";

export const GetSubscriptionLinksPathParamsSchema = z.object({
  subscriptionLinkId: z.uuid(),
});

export type GetSubscriptionLinksPathParamsType = z.infer<
  typeof GetSubscriptionLinksPathParamsSchema
>;

export const GetSubscriptionLinksResponseBodySchema = z.object({
  stripeSubscriptionLinks: StripeSubscriptionLinkDtoSchema.array(),
});

export type GetSubscriptionLinksResponseBodyType = z.infer<
  typeof GetSubscriptionLinksResponseBodySchema
>;
